function handleVideoPlayback(element,index) {
  const slides = element.querySelectorAll('.swiper-slide');
  const activeIndex = index; 
  
  slides.forEach((slide, index) => {
    const video = slide.querySelector('video');

    if (index === activeIndex) {
      if (video) {
        video.play().then(() => {
        }).catch((error) => {
          console.error('Video play was prevented:', error);
        });
      }
    } else {
      if (video) {
        video.pause();
        video.currentTime = 0;
      }
    }
  });
}
function switchTab (params) {
  var index = params * 1;
  $('.aligned-links-left .bike-nav-tab-item').eq(index).addClass("active").siblings().removeClass("active");
  $(".bike-nav-tab__item").eq(index).addClass("active").siblings(".bike-nav-tab__item").removeClass("active");
}
function openPanel(el) {
  var $panelSubcontent = $(el).next('.panel-subcontent');
  var $panel = $(el).parent('.panel');

  if ($panelSubcontent.is(':visible')) {
      $panelSubcontent.slideUp();
      $panel.removeClass('open');
  } else {
      $panelSubcontent.slideDown();
      $panel.addClass('open');
  }
}
function openPagePop(content,name) {
  var el = `#custom_popup`;
  var id = "custom_popup"
  console.log(content, name)
  if(name=="Customizable"){
    $(`#${id} .popup__content`).html("<div class='pop-text-content'><div class='pb-20'>Choose from 15 acceleration curves across Eco, Trail, and Boost modes, each with 5 pedal assist levels on the control panel or in the Velotric app. Adjust speed and power to match your ride—whether for efficiency, balance, or max performance.</div><div class='pb-10'></div></div>")
  }else if(name=="Battery IPX7"){
    $(`#${id} .popup__content`).html("<div class='pop-text-content'><div class='pb-20'>IPX7 Waterproof Battery, IPX6 Waterproof Bike for all-weather riding</div></div>")
  }else if(content=="key"){
    $(`#${id} .popup__content`).html('<img class="pop-mb-hide" src="https://cdn.shopify.com/s/files/1/0599/2094/1239/files/20240228-183235.jpg?v=1709116378" width="910" height="auto" /><img class="pop-mb-show" src="https://cdn.shopify.com/s/files/1/0599/2094/1239/files/20240228-183235.jpg?v=1709116378" width="393" height="auto" /><div class="pop-text-content"><div><p>You can locate the number in the area indicated in the picture above. The number begins with VL CT or KL, and you only need to type in the numerical digits.</p></div></div>')
  }else if(content=="doublepoints"){
    $(`#${id} .popup__content`).html('<div class="pop-text-content" style="background-color: #A4E4FF;margin:0;max-width: 100%;"><img src="https://cdn.shopify.com/s/files/1/0599/2094/1239/files/frame_48101405.webp?v=1718958091" /></div>')
  }else if(content=="fold_1"){
    $(`#${id} .popup__content`).html('<div class="pop-text-content back-in-stock"><h3>Velotric Fold 1 E-Bike</h3><div class="pb-15">Sign up to receive a notification when this item is back in stock and available to ship.</div><div class="pb-15"><input type="email" placeholder="Email" class="back_in_stock form-control" /></div><button type="submit" class="btn btn-success btn-lg col-xs-12" onclick="notifysubmit()">Notify Me When It Is In Stock</button><div id="completed_message" class="completed_message alert alert-success" style="display: none;">You are in! We will let you know when this item is back in stock and available to ship.</div></div>')
  }else if(content=="breeze_1" && name=="Low"){
    $(`#${id} .popup__content`).html(`<div class='pop-text-content'>
    <div class='pb-20'>
      <h6>What does 'Low Motor Noise' mean?</h6>
      <div class="pb-10">Delivering mighty 750W power with industry-leading quietness, Breeze 1 operates at just 58dB - 9x quieter than average Ebike players (68dB).</div>
      <h6>Why does it matter?</h6>
      <div>A super quiet motor like Breeze 1’s means two awesome things for you:</div><div>1. Enjoy your ride in peace – No ear-piercing buzz or rumble. Hear only the sound of nature & your breath – yeah, that’s how calm it is.</div><div>2. Stay discreet – When you ride with friends, they’ll think you’re on a regular bike… because there’s barely any noise to give it away!</div>
    </div></div>`)
  }else if(name=="all"){
    $(`#${id} .popup__content`).html('<div class="pop-text-content"><h3 class="pb-15 text-center">VELOTRIC</h3><div class="pb-15">Notice: Due to the implementation of new Tariffs, pricing on select models may increase starting <strong>April 15th, 2025</strong>. This decision is necessary to ensure that we can continue to provide the high-quality Ebikes you love, while meeting the new tariffs. You can still enjoy current prices if you purchase before April 15th. Don’t miss your chance—lock in the best deal today!</div><div class="pb-15"></div></div>')
  }else if(name=="donate"){
    $(`#${id} .popup`).addClass("donate")
    $(`#${id} .popup__content`).html(`<div class="pop-text-content"><img class="mb-down--hide" src="https://cdn.shopify.com/s/files/1/0599/2094/1239/files/frame_48101389.webp?v=1729671878"/><img class="mb-up--hide" src="https://cdn.shopify.com/s/files/1/0599/2094/1239/files/frame_48101389_2.webp?v=1730102600"/><div class="donate-content">
    <div class="donation-type">
      <div class="donation-type-title">100% of your donation supports two amazing NGOs:</div>
      <div class="donation-item">
        <div class="item"><img src="https://cdn.shopify.com/s/files/1/0599/2094/1239/files/frame_48101368_4.webp?v=1730453107"/><div class="title">The Solutions Project</div><div class="content">Leading efforts to tackle climate change.</div></div>
        <div class="item"><img src="https://cdn.shopify.com/s/files/1/0599/2094/1239/files/frame_48101368_2.webp?v=1730453111"/><div class="title">Clean Air Task Force</div><div class="content">Advancing sustainable living worldwide.</div></div>
      </div>
    </div>
    <div class="donation-info">
      At Velotric, we believe every ride should bring us closer to a healthier planet. Ebikes are fun, eco-friendly, and help reduce carbon emissions. By choosing Velotric, you’re joining a movement toward a more sustainable tomorrow. 🌿🚴‍♂️
    </div><div class="donate-button"><a href="/blogs/story-landing/ready-to-beat-black-friday-jumpstart-your-savings-save-the-planet" class="btn btn--solid" target="_blank">Learn More</a></div></div></div>`)
  }
  if(content=="compare"){
    var selectedProducts = null;
    if(localStorage.getItem('compare_list') == "undefined"){
      selectedProducts = [];
      selectedProducts.push(name)
      localStorage.setItem('compare_list', JSON.stringify(selectedProducts));
    }else{
      selectedProducts = (JSON.parse(localStorage.getItem('compare_list')) && JSON.parse(localStorage.getItem('compare_list')).length > 0) ? JSON.parse(localStorage.getItem('compare_list')) : [];
      if (!selectedProducts.includes(name)) {
        selectedProducts.push(name)
        localStorage.setItem('compare_list', JSON.stringify(selectedProducts));
      }
    }
    
    $("#compare_popup").addClass("active")
  }else{
    $(el).addClass("active")
  }
  
}
$(".custom-popup-group .popup.popup-promo").on('click', function(e) {
  if ($(e.target).closest('.popup__content').length > 0) {
  } else {
    $(".custom-popup-group").removeClass("active");
  }
});
$(".custom-popup-group .popup__close-button").on('click', function(e) {
  $(".custom-popup-group").removeClass("active"); 
});

if(document.querySelectorAll('.testimonial-box-container').length > 0){
  document.querySelectorAll('.professional-testimonial-container').forEach(function(element){
    var swiper_elem_1 = element.querySelector('.testimonial-box-container');
    var swiper_elem_2 = element.querySelector('.testimonial-thumbs');
    var pagination_elem = element.querySelector('.swiper-pagination');
    var swiper = new Swiper(swiper_elem_2, {
      spaceBetween: 0,
      slidesPerView: 5,
      freeMode: true,
      
      // autoHeight: true, // Disabled: make all slides same height
      watchSlidesProgress: true,
      breakpoints: {
        320: {
          slidesPerView: 3
        },
        480: {
          slidesPerView: 3
        },
        768: {
          slidesPerView: 4
        },
        1300: {
          slidesPerView: 5
        }
      },
      spaceBetween: 50,
    });
    var swiper2 = new Swiper(swiper_elem_1, {
      spaceBetween: 0,
      slidesPerView: 1,
      slidesPerGroup: 1,
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      speed: 1000,
      // autoplay:true,
      // autoHeight: true, // Disabled: make all slides same height
      thumbs: {
        swiper: swiper,
      },
      pagination: {
        el: pagination_elem,
        clickable: true,
      },
    });
  });
}
if(document.querySelectorAll('.kol-slider-container').length > 0){
  document.querySelectorAll('.kol-testimonials-container').forEach(function(element){
    var swiper_elem_1 = element.querySelector('.kol-slider-container');
    var pagination_elem = element.querySelector('.swiper-pagination');
    
    var swiper1 = new Swiper(swiper_elem_1, {
      preloadImages: false,
      lazy: true,
      spaceBetween: 30,
      slidesPerView: 2.5,
      breakpoints: {
        320: {
          slidesPerView: 1
        },
        480: {
          slidesPerView: 1
        },
        768: {
          slidesPerView: 1
        },
        1100: {
          slidesPerView: 1.5
        },
        1800: {
          slidesPerView: 2.5
        }
      },
      // breakpoints: {
      //   1024: {
      //     width: 720,
      //   },
      //   589: {
      //     width: 328
      //   }
      // },
      loop: true,
      pagination: {
        el: pagination_elem,
        clickable: true,
      },
      navigation: {
        nextEl: '.carousel-btn.next',
        prevEl: '.carousel-btn.prev'
      },
      mousewheel: {
        forceToAxis: true,
      },
      slideToClickedSlide: true,
      threshold: 12,
      on: {
        slideChange: function () {
          if(this.activeIndex != 0){
            handleVideoPlayback(element,this.activeIndex);
          }     
        }
      }
    });
  });
}
if(document.querySelectorAll('.imgWTS-container').length > 0){
  document.querySelectorAll('.imgWithText-slideshow-container').forEach(function(element){
    var swiper_elem_1 = element.querySelector('.imgWTS-container');
    var pagination_elem = element.querySelector('.swiper-pagination');
    
    var swiper1 = new Swiper(swiper_elem_1, {
      preloadImages: true,
      lazy: false,
      slidesPerView: 1,
      spaceBetween: 5,
      autoplay: {
        delay: 4000,
        stopOnLastSlide: false,
        disableOnInteraction: true,
      },
      loop: true,
      pagination: {
        el: pagination_elem,
        clickable: true,
      },
      navigation: {
        nextEl: '.carousel-btn.next',
        prevEl: '.carousel-btn.prev'
      },
      mousewheel: {
        forceToAxis: true,
      },
      slideToClickedSlide: true,
      threshold: 12
    });
  });
}
if(document.querySelectorAll('.features-review-section-wrapper').length > 0){
  document.querySelectorAll('.features-review-section-wrapper').forEach(function(element){
    var swiper_elem = element.querySelector('.swiper');
    var per_row = element.getAttribute('data-per-row');
    var pagination_elem = element.querySelector('.swiper-pagination');
    var prev_nav_elem = null;
    var next_nav_elem = null;
    if(element.querySelector('.swiper-navigation'))
    {
      prev_nav_elem = element.querySelector('.swiper-button-prev');
      next_nav_elem = element.querySelector('.swiper-button-next');
    }
    new Swiper(swiper_elem, {
      // Optional parameters
      loop: true,
      slidesPerView: 1,
      spaceBetween: 0,
      pagination: {
        el: pagination_elem,
        clickable: true,
      },
      navigation: {
        nextEl: next_nav_elem,
        prevEl: prev_nav_elem,
      },
      breakpoints: {
        870: {
          slidesPerView: 2,
          spaceBetween: 10,
        },
        1024: {
          slidesPerView: per_row,
          spaceBetween: 20,
        },
      }
    });
  });
}

/*** product bundle ***/
$('.js_bundle').click(function() {
    var $that = $(this).closest(".bundle-wrap");
    var bundle_item = $that.attr("data-bundle");
    var ischeck = null;
    if($that.hasClass("active")){
      $that.removeClass("active");
      ischeck = false; 
    }else{
      $that.addClass("active").siblings().removeClass("active");
      ischeck = true;
    }

   var rebuyItems = $('.rebuy-container .acc-addon__item');
    var bike = $(".product-general-info-block h1.h5").text();
    if(bike.indexOf("Discover 1") > -1 && bundle_item == "a"){
      var product_title_arr = ["Velotric Discover 1 Rear Rack","Velotric Front Basket","Velotric Phone Mount","Velotric Left Mirror"]
    }else if(bike.indexOf("Discover 2") > -1 && bundle_item == "a"){
      var product_title_arr = ["Velotric Front Basket","Velotric Suspension Seatpost 2.0","Velotric Left Mirror","Velotric Phone Mount"]
    }else if(bike.indexOf("Summit 1") > -1 && bundle_item == "a"){
      var product_title_arr = ["Velotric Summit 1 Rear Rack","Velotric Summit 1 Fender","Velotric Phone Mount","Velotric Left Mirror"]
    }else if(bike.indexOf("Breeze 1") > -1 && bundle_item == "a"){
      var product_title_arr = ["Velotric Breeze 1 Fender","Velotric Breeze 1 Rear Rack","Velotric Phone Mount","Velotric Left Mirror"]
    }else if(bike.indexOf("Fold 1 Ebike") > -1 && bundle_item == "a"){
      var product_title_arr = ["Velotric Front Basket","Velotric Suspension Seatpost 2.0","Velotric Wheel Guard","Velotric Phone Mount"]
    }else if(bike.indexOf("Fold 1 Plus") > -1 && bundle_item == "a"){
      var product_title_arr = ["Velotric Front Basket","Velotric Left Mirror","Velotric Phone Mount"]
    }else if(bike.indexOf("Fold 1 Plus") > -1 && bundle_item == "b"){
      var product_title_arr = ["Velotric Rack Top Bag","Velotric Suspension Seatpost 2.0","Velotric Phone Mount"]
    }else if(bike.indexOf("Fold 1 Lite") > -1 && bundle_item == "a"){
      var product_title_arr = ["Velotric Front Basket","Velotric Suspension Seatpost 2.0","Velotric Wheel Guard","Velotric Fold 1 Lite Rear Rack"]
    }else if(bike.indexOf("T1 ST") > -1 && bundle_item == "a"){
      var product_title_arr = ["Velotric Phone Mount","Velotric Rear Rack Pannier Bag","Velotric T1 Series Fender Pack","Velotric Left Mirror"]
    }else if(bike.indexOf("Nomad 1") > -1 && bundle_item == "a"){
      var product_title_arr = ["Velotric Phone Mount","Velotric Nomad 1 Rear Rack","Velotric Front Basket","Velotric Left Mirror"]
    }else if(bike.indexOf("Nomad 2") > -1 && bundle_item == "a"){
      var product_title_arr = ["Velotric Front Basket","Velotric Rear Basket (M) 2.0","Velotric Left Mirror","Velotric Phone Mount"]
    }else if(bike.indexOf("Go 1") > -1 && bundle_item == "a"){
      var product_title_arr = ["Velotric Seat Pad","Velotric Rear Pegs","Velotric Packer 1 / Go 1 Passenger Handrail"]
    }else if(bike.indexOf("Packer 1") > -1 && bundle_item == "a"){
      var product_title_arr = ["Velotric Packer 1 Seat Pad","Velotric Packer 1 Passenger Foot Rest","Velotric Packer 1 Child Safety Balustrade"]
    }
   if(product_title_arr){
     rebuyItems.each(function () {
      var title = $(this).find('.acc-addon__item-info .rebuy-product-title').text();
      var checkbox = $(this).find('.checkbox-input.acc-checkbox');
      if(product_title_arr.indexOf(title) > -1){
        console.log(checkbox.prop('checked'))
        if(!checkbox.prop('checked') && title == "Velotric Packer 1 Seat Pad"){
          checkbox.prop('checked', true);
        }
        if(!checkbox.prop('checked') && $that.hasClass("active")){
          checkbox.trigger('click');
        }else if(checkbox.prop('checked') && !$that.hasClass("active")){
          checkbox.trigger('click');
        }
        
      }else{
        if(checkbox.prop('checked')){
          checkbox.trigger('click');
        }
      }
    })
   }    
  })
// $('.bundle_img').click(function() {
//     var imageUrl = $(this).find("img").attr('src');
//     $('.zoomed-image').attr('src', imageUrl);
//     $('.bundle-image-overlay').addClass('active');
//   });

  $('.bundle-image-overlay').click(function() {
    $(this).removeClass('active');
  });
  $(document).on('click','#rebuy-expandButton', function() {
    var $el = $('.rebuy-wrap .acc-addon__items');
    var $tabcontent = $('.rebuy-wrap #offer');
    var open = null;
    if($el.hasClass("rebuy-collapse")){
      $el.removeClass("rebuy-collapse");
      $(".rebuy-footer a").text("");
      open = false;
    } else{
      $el.addClass("rebuy-collapse");
      open = true;
      // if(!$tabcontent.hasClass("active")){
      //   $(".rebuy-footer a").text("View All Accessories");
      // }   
    } 
    $(this).text($el.hasClass("rebuy-collapse") ? 'Show Less' : 'Show More');
    var _window_dataLayer;   
    const breadcrumb = $(".breadcrumbs .breadcrumb__link").text().trim();
    const buttonName = $(this).text().trim();
    const parameters = { page_name: "Product Page_" + breadcrumb,button_name: buttonName,action:open  };
    null === (_window_dataLayer = window.dataLayer) || void 0 === _window_dataLayer ? void 0 : _window_dataLayer.push({ event: "ga4Event", event_name: "click_acc_btn", event_parameters: parameters });
  });

  $(document).on('click','.rebuy-footer a', function() {
    var _window_dataLayer;   
    const breadcrumb = $(".breadcrumbs .breadcrumb__link").text().trim();
    const buttonName = $(this).text().trim();
    const parameters = { page_name: "Product Page_" + breadcrumb,button_name: buttonName  };
    null === (_window_dataLayer = window.dataLayer) || void 0 === _window_dataLayer ? void 0 : _window_dataLayer.push({ event: "ga4Event", event_name: "click_acc_btn", event_parameters: parameters });
  });

  function isThreeOrMoreChecked(checkboxes) {
    let checkedCount = 0;
    let totalValue = 0;
    for (const checkbox of checkboxes) {
        if (checkbox.checked) {
            checkedCount++;
            var savedP = parseFloat(checkbox.closest(".acc-addon__item").dataset.saved)
            totalValue += savedP;
        }
    }
    totalValue = totalValue.toFixed(2);
    return [checkedCount,totalValue];
  }
  // $('#compatible .acc-addon__item .acc-addon__item-image, #compatible .acc-addon__item .acc-addon__item-product-title, #offer .acc-addon__item .acc-addon__item-image, #offer .acc-addon__item .acc-addon__item-product-title').on('click', function() {
  //   var checkbox = $(this).closest(".acc-addon__item").find('.checkbox-input.acc-checkbox');
  //   checkbox.prop('checked', !checkbox.prop('checked')).change();
  //   var _window_dataLayer;
  //   const breadcrumb = $(".breadcrumbs .breadcrumb__link").text().trim();
  //   const buttonName = $(this).closest(".acc-addon__item").find(".acc-addon__item-product-title").text().trim();
  //   const parameters = { page_name: "Product Page_" + breadcrumb,button_name: buttonName,action:!checkbox.prop('checked')  };
  //   null === (_window_dataLayer = window.dataLayer) || void 0 === _window_dataLayer ? void 0 : _window_dataLayer.push({ event: "ga4Event", event_name: "click_accessories", event_parameters: parameters });
  // });

 $('.rebuy-container #offer input[type="checkbox"]').change(function() {
  const checkboxes = $('.rebuy-container #offer input[type="checkbox"]');
  var num = $(this).closest(".acc-addon__item").data("num") * 1;
  if(num > 0){
    var sales = $(".rebuy-container .tab-button.active").data("sale")
    const data = isThreeOrMoreChecked(checkboxes);
    if(data[0] < num){     
      $(".rebuy-container .saved_text").text(`Add ${num - data[0]}, save ${sales}%`)
      $(".rebuy-container .sale_price").addClass("hidden")
      $(".rebuy-container .offer_price").removeClass("del")
      if ($(".rebuy-container .offer-origin_price").length > 0) {$(".rebuy-container .offer-origin_price").removeClass("hidden")}
    }else{
      $(".rebuy-container .saved_text").text(`Order Now & Save $${data[1]}`)
      $(".rebuy-container .sale_price").removeClass("hidden")
      $(".rebuy-container .offer_price").addClass("del")
      if ($(".rebuy-container .offer-origin_price").length > 0) {$(".rebuy-container .offer-origin_price").addClass("hidden")}
    }
  }
});
// acc-select change
$('.rebuy-container #offer .acc-addon__items .acc-select').on('change', function() {
  // var selectedPrice = $('option:selected', this).data('price');
  var selectedImage = $('option:selected', this).data('image');
  // $(".rebuy-money-val").text(selectedPrice);
  if(selectedImage){
    var image= $(this).closest('.acc-addon__item').find('.acc-addon__item-image img');
    image.attr("src",selectedImage)
  }
})
// product bundle quick view
$(document).on('click','.quick-view__content .add-acc-btn', function() {
  const form = $(this).closest(".product__info").find(".product-form-wrap form");
  var productId = form.find('input[name="product-id"]').val()*1;
  var vId = form.find('input[name="id"]').val();
  $('.rebuy-wrap .tab-content.active .acc-addon__items product-card').each(function() {
    var productCardId = $(this).data('id');
    if (productCardId === productId) {
      $(this).find('input[type="checkbox"]').prop('checked', true);
      var selectElement = $(this).find('select');
      if (selectElement.length) {
        selectElement.val(vId);
        selectElement.trigger('change');
      }
    }
  });
 $(".body-overlay").trigger('click');
})
  function openTab(evt, tabName,wrapClass) {
    var i, tabcontent, tabbuttons;
    var wrap = document.querySelector("."+wrapClass);
    tabcontent = wrap.querySelectorAll(".tab-content");
    for (i = 0; i < tabcontent.length; i++) {
      tabcontent[i].classList.remove("active");
    }
    tabbuttons = wrap.querySelectorAll(".tab-button");
    for (i = 0; i < tabbuttons.length; i++) {
      tabbuttons[i].className = tabbuttons[i].className.replace(" active", "");
    }
    wrap.querySelector("#" + tabName).classList.add("active");
    
    evt.currentTarget.className += " active";
  }
/*** end product bundle ***/

$(document).on('click','.product-media-carousel_thumbs_wrap .carousel__slide', function() {
  var videoWrap = $(this).parents(".product-media-carousel_thumbs_wrap").siblings('.product-media-video');
  if (videoWrap.length) {
      videoWrap.addClass("hide");
      $(".toggle-image_video[data-name='image']").addClass("active").siblings().removeClass("active");
  }
})
$(document).on('click','.pdp-toggle-image_video .toggle-image_video', function() {
  var name = $(this).data('name');
  $(this).addClass("active").siblings().removeClass("active");
  var videoWrap = $(this).parents("div[data-product-media-container]").find('.product-media-video');
  if(name == "image"){
    videoWrap.addClass("hide");
  }else{
    videoWrap.removeClass("hide");
  }
})
/*** atc  add to cart  ***/
// function setLoading(isLoading) {
//     document.querySelectorAll('button.js_custom_atc').forEach(button => button.classList.toggle('loading', isLoading));
// }
// function setDisable(isDisable) {
//     document.querySelectorAll('button.js_custom_atc').forEach(button => button.toggleAttribute('disabled', isDisable));
// }

// function atc_getQty(container) {
//   var qty =  1;
//   if (parseFloat(qty) == parseInt(qty) && !isNaN(qty)) {
//     // We have a valid number!
//   } else {
//     // Not a number. Default to 1.
//     qty = 1;
//   }
//   return parseInt(qty);
// }

// function atc_change(container, qty) {
//   if (qty <= 1) {
//     qty = 1;
//   }
//   container.querySelector(".js-qty__num").value = qty;
// }

// function handleQtyButtons(container) {
//   container.querySelector(".js-qty__adjust--plus").addEventListener("click", function () {
//     var qty = atc_getQty(container);
//     atc_change(container, qty + 1);
//   });

//   container.querySelector(".js-qty__adjust--minus").addEventListener("click", function () {
//     var qty = atc_getQty(container);
//     atc_change(container, qty - 1);
//   });

//   container.querySelector(".js-qty__num").addEventListener("change", function (evt) {
//     atc_change(container, atc_getQty(container));
//   });
// }
// function updateCartDrawer(response) {
//     const sectionHtml = response.sections['sections--17122702393527__cart-drawer'];
//     if (sectionHtml) {
//         $('#shopify-section-sections--17122702393527__cart-drawer').html(sectionHtml);
//         $('button.unstyled-button[data-sidebar-id="CartDrawer"]').click();
//         var count = $("#CartDrawer .cart-drawer__header-product-count").text().split(" ")[0].replace("(","");
//         console.log(count)
//         $("button.unstyled-button[data-sidebar-id='CartDrawer'] #CartCount").html(`<div class="cart-count "><span aria-hidden="true">${count}</span></div>`)
//     } else {
//         console.log('无法获取更新后的购物车内容');
//     }
//     if (BSS_B2B) {
//       setTimeout(()=>{
//         BSS_B2B.cart.fixer(JSON.parse($('#bss-b2b-store-data').html()),false, true);
//         BSS_B2B.cp.changeProductPrice(JSON.parse($('#bss-b2b-store-data').html()),false, false);
//         BSS_B2B.handleCartCheckoutBtn(JSON.parse($('#bss-b2b-store-data').html()))
//       },1000)
//     }
// }
// function handleAddToCart(container) {
//   $(container).on("click", ".js_custom_atc", function (e) {
//     e.preventDefault();

//       setDisable(true)
//       setLoading(true)

//     var $variantSelector = $(container).find('[name="id"]');
//     // console.log('clicked');
//     var itemId = $(this).attr("data-id") || $variantSelector.val();

//     var quantity = atc_getQty(container);
//     var itemName = $(this).attr("data-name")
//     var productsToAdd = [
//       { id: itemId, quantity: quantity }
//     ]
//     var freeitemIds = $(this).attr("data-freeitem");
//     if(freeitemIds){
//       var idArray = freeitemIds.slice(0, -1).split(',');
      
//       var newProducts = idArray.map(function (id) {
//         return { id: id, quantity: 1 };
//       });
  
      
//       Array.prototype.push.apply(productsToAdd, newProducts);
//     }
//     var rebuyItems = $('.rebuy-container .rebuy-wrap #compatible .acc-addon__item, .rebuy-container .rebuy-wrap #offer .acc-addon__item')
//     var rebuyItemsFree = $('.rebuy-container .rebuy-wrap #free .acc-addon__item');
//     if(rebuyItems){
//       rebuyItemsFree.each(function () {
//         var checkbox = $(this).find('.checkbox-input.acc-checkbox');
//         var select = $(this).find('.acc-select');
//         if(checkbox.prop('checked')){
//           checkRebuyItem = true;
//           var variant = null;
//           var name = $(this).find(".acc-addon__item-product-title").text()
//           if(select.length > 0){
//             variant = select.val();
//           }else{
//             variant = $(this).attr("data-variant")
//           }
          
//           productsToAdd.push({id:variant,quantity:quantity})
    
//         }           
//       });
//       rebuyItems.each(function () {
//         var checkbox = $(this).find('.checkbox-input.acc-checkbox');
//         var select = $(this).find('.acc-select');
//         if(checkbox.prop('checked')){
//           checkRebuyItem = true;
//           var variant = null;
//           var name = $(this).find(".acc-addon__item-product-title").text()
//           if(select.length > 0){
//             variant = select.val();
//             console.log(variant)
//           }else{
//             variant = $(this).attr("data-variant")
//           }
          
//           productsToAdd.push({id:variant,quantity:1})
 
//         }           
//       });
//     }
    
 
//     let mydata = {
//         items: productsToAdd
//     };
//     const formData = new FormData();

//     // 将 items 数组添加到 FormData 中
//     mydata.items.forEach((item, index) => {
//         formData.append(`items[${index}][id]`, item.id);
//         formData.append(`items[${index}][quantity]`, item.quantity);
//     });
    
//     // 如果你有其他参数需要添加，比如 `sections` 和 `sections_url`:
//     formData.append('sections', ['sections--17122702393527__cart-drawer']); // 假设你要更新购物车抽屉部分
//     formData.append('sections_url', window.location.pathname);
//     $.ajax({
//         type: 'POST',
//         url: '/cart/add.js',
//         data: formData,
//         contentType: false,  
//         processData: false, 
//         dataType: 'json',
//         error:function(error){
//             e = JSON.parse(error.responseText);
//             desc = e.description;
//             alert(desc);
//         },
//         success:function(response){
//            setDisable(false)
//            setLoading(false)
//            updateCartDrawer(response);
            
//         },
//         complete: function() {
            
//         }
//     });
//   })
// }
// document.querySelectorAll("#atcDrawer .js_custom_atc_module").forEach(function (container) {
//   handleQtyButtons(container);
//   handleAddToCart(container);
// });
// document.querySelectorAll(".product-card-container .js_custom_atc_module").forEach(function (container) {
//   // handleQtyButtons(container);
//   handleAddToCart(container);
// });


document.addEventListener('change', function(event) {
  if (event.target.matches('.product-form.multiple-variants .cart-drawer-related__variant')) {
    var selectElement = event.target;
    var selectedValue = selectElement.value;
    console.log('select:', selectedValue);
    
    var form = selectElement.closest('form');
    var idInput = form.querySelector('input[name="id"]');
    idInput.value = selectedValue;
    document.querySelector(".cart-drawer").classList.remove('is-cart-loading');
  }
});

/*** product card 2 hover ***/
  // $(document).on({
  //   mouseenter: function() {
  //     const img = $(this).find('.product-card__img');
  //     const productImg = img.attr('data-src'); 
  //     const secondImage = img.attr('data-hover');       
  //     if (secondImage) { 
  //       img.attr('src', secondImage); 
  //     }
  //   },
  //   mouseleave: function() {
  //     const img = $(this).find('.product-card__img'); 
  //     const productImg = img.attr('data-src'); 
  //     const secondImage = img.attr('data-hover'); 
  //     if (secondImage) {  img.attr('src', productImg); }
  //   }
  // },'.multiple-grid-item__desktop-content .product-card .product-card__images-wrapper')

/*** call us ***/
function updateCartNote(){
  fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ note: "clickedcallus" })
  })
  .then(response => response.json())
  .then(data => {
    console.log('Order note updated:', data);
  })
  .catch(error => {
    console.error('Failed to update order note:', error);
  });
}
const callUsIcon = document.querySelector('.call-us-icon');
const callIcon = document.querySelector('.call-icon');
const closeIcon = document.querySelector('.call_us_close');
const closeIconSvg = document.querySelector('.call_us_close_icon')
const callUsDetails = document.querySelector('.call-us-details');

if (callUsIcon) {
  callUsIcon.addEventListener('click', () => {
    const isHidden = callUsDetails.classList.toggle('custom_hidden');
    
    callIcon.classList.toggle('custom_hidden', !isHidden);
    closeIcon.classList.toggle('custom_hidden', isHidden);
    closeIconSvg.classList.toggle('active', !isHidden);
    callUsIcon.classList.toggle('active');
    localStorage.setItem('called_us', 'true');
    updateCartNote()
  });
}

function openPhone(){
  window.location.href = "tel:+18885593099";
  localStorage.setItem('called_us', 'true');
  updateCartNote()
}
const calledUs = window.localStorage.getItem('called_us') === 'true';
if(calledUs){
  updateCartNote()
}

document.querySelectorAll('.smooth-scroll').forEach(anchor => {
  anchor.addEventListener('click', function(e) {
    e.preventDefault();
    const targetId = this.getAttribute('href').substring(1);
    const targetElement = document.getElementById(targetId);
    
    if (targetElement) {
      window.scrollTo({
        top: targetElement.offsetTop,
        behavior: 'smooth' 
      });
    }
  });
});
// N2 geometry
var toggleSwitch = document.getElementById('toggleSwitch');
if (toggleSwitch) {
  toggleSwitch.addEventListener('change', function () {
    var stepThruContent = document.getElementById('stepThruContent');
    var highStepContent = document.getElementById('highStepContent');
    if (this.checked) {
      stepThruContent.style.display = 'none';
      highStepContent.style.display = 'block';
    } else {
      stepThruContent.style.display = 'block';
      highStepContent.style.display = 'none';
    }
  });
}



